module.exports = __webpack_public_path__ + "img/logo-yvivre-white.8c1c68e3.svg";